module.exports = __webpack_public_path__ + "img/car-3.a87d9de9.png";